export default __webpack_public_path__ + "static/media/popover_cancel.9377d6ce.svg";